import PropertyItemTypeEnum from "../PropertyItemTypeEnum";
import PropertyTranslator from "../PropertyTranslator";
import { mmFromSceneUnits, sceneUnitsFromMm } from "../../../utils/scaler";
import Constants from "../../../constants";

const MM_PER_CM = 10;

// Like lengthCmTranslator, but for extrusion depth specifically: depth can be negative (the
// extrusion flips to the opposite side of the profile), so unlike a plain length field this
// rejects a value by magnitude rather than by sign — anything smaller in absolute value than
// Constants.MIN_EXTRUSION_DEPTH_MM is rejected, matching the same floor the depth edit handle
// enforces, but the sign itself (which side the extrusion points to) is free to be either.
const extrusionDepthCmTranslator: PropertyTranslator<number> = {
    getItemType: () => PropertyItemTypeEnum.Length,

    getDisplayValue: (value) => {
        const cm = mmFromSceneUnits(value) / MM_PER_CM;
        return String(Math.round(cm * 100) / 100);
    },

    setValue: (displayText) => {
        const cm = Number(displayText.trim().replace(',', '.'));
        if (!Number.isFinite(cm) || Math.abs(cm) * MM_PER_CM < Constants.MIN_EXTRUSION_DEPTH_MM) return { ok: false };

        return { ok: true, value: sceneUnitsFromMm(cm * MM_PER_CM) };
    },

    isEqual: (a, b) => Math.abs(a - b) < 1e-9,

    getListType: () => 'none',

    usesButton: () => false,

    refreshOnEdit: () => true,
};

export default extrusionDepthCmTranslator;
